import React, {Component} from 'react'
import { Link } from 'gatsby'
import logo from '../images/ValitonLogo.svg'
import * as styles from '../css/header.module.scss'

class Header extends Component {

    handleLinkClick = () => {
        this.checkbox.checked = false;
    };

    render() {
        return (
            <header>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4 col-md-3">
                            <div className={styles.companyLogo}>
                                <Link to={"/"}>
                                    <img className={styles.logo} src={logo} alt="Valiton Logo" />
                                </Link>
                            </div>
                        </div>

                        <div className="col-sm-8 col-md-9">
                            <nav role="navigation">
                                <div className={styles.menuToggle}>
                                    <input type="checkbox"
                                           title="menu"
                                           ref={(checkbox) => this.checkbox = checkbox}
                                    />

                                    <span/>
                                    <span/>
                                    <span/>

                                    <ul className={styles.main_menu}>
                                        <li>
                                            <Link onClick={this.handleLinkClick}
                                                  activeClassName={styles.active}
                                                  title="Zur Service-Seite"
                                                  to={"/service"}
                                            >
                                                Service
                                            </Link>
                                        </li>

                                        <li>
                                            <Link onClick={this.handleLinkClick}
                                                  activeClassName={styles.active}
                                                  title="Zur Über-Uns-Seite"
                                                  to={"/ueber-uns"}
                                            >
                                                Über uns
                                            </Link>
                                        </li>

                                        <li>
                                            <Link onClick={this.handleLinkClick}
                                                  activeClassName={styles.active}
                                                  title="Zur Karriere-Seite"
                                                  to={"/karriere"}
                                            >
                                                Karriere
                                            </Link>
                                        </li>

                                        <li>
                                            <Link onClick={this.handleLinkClick}
                                                  activeClassName={styles.active}
                                                  title="Zum Technology-Radar"
                                                  to={"/technology-radar"}
                                            >
                                                Tech-Radar
                                            </Link>
                                        </li>

                                        <li>
                                            <Link onClick={this.handleLinkClick}
                                                  activeClassName={styles.active}
                                                  title="Zur Kontakt-Seite"
                                                  to={"/kontakt"}
                                            >
                                                Kontakt
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header



